import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface QuickStatsProps {
  thisMonth?: number;
  lastMonth?: number;
  growth?: string;
  avgPerClient?: number;
}

const QuickStats = ({
  thisMonth = 2450.5,
  lastMonth = 2178.25,
  growth = '+12.5%',
  avgPerClient = 612.63,
}: QuickStatsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Stats</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">This Month</span>
          <span className="font-semibold">${thisMonth.toFixed(2)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Last Month</span>
          <span className="font-semibold">${lastMonth.toFixed(2)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Growth</span>
          <span className="font-semibold text-green-600">{growth}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Avg per Client</span>
          <span className="font-semibold">${avgPerClient.toFixed(2)}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickStats;
